import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'la',
    fullName: 'Latin',
    nativeName: 'Latin',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Aliquid Prodigiosus venit",
    landing_subtitle: "ArgVoid est app ac ludum evolutionis studio. Siste suavi, nova mox veniunt!",
    select_language: "Linguae Selectae",
    search_placeholder: "Quaerere linguas...",
    terms_title: "Termini servitii",
    policy_title: "Privacy Policy",
    cookies_title: "Crustulum Policy",
    terms_content: `
        <strong>1. Acceptatio Terms</strong><br>
        ArgVoid accessu, haec servitii condiciones acceptae sunt. Si haec vocabula non conveniant, servitium adhibendum non est.<br><br> .

        <strong>2. Rostra Usage</strong><br>
        ArgVoid eiusque applicationes praebentur "ut" ad proposita informationales et creatrix. Ministerium nonnisi ad legitimas causas utendum est

        <strong>3. prohibitorum Conduct</strong><br>
        Situs vulnerabilities, spamming, vel accessum alienum ad infrastructuram tentans stricte prohibitus est.<br><br>.

        <strong>4. Disclaimer</strong><br>
        suggestum et officia aliquo tempore sine nota immutari possunt. Nulla warantizatio providetur circa servitium uptime vel disponibilitate.
    `,
    policy_content: `
        <strong>1. Information Collection</strong><br>
        In suggestu usoris authenticas vel rationem creationis hoc tempore non requirit. Nulla personalis notitia cognoscendi (ut nomina vel inscriptio electronica) active colligitur ex visitors.<br><br>

        <strong>2. Syntaxis Data</strong><br>
        Basica, anonymizata analytica colligi potest ad intelligendum locum negotiationis et applicationes emendare. Haec data singulis usorum identitatibus non coniungitur.<br><br>

        <strong>3. Tertium-Party Services</strong><br>
        Tertia-pars provisores adhiberi possunt ad officia obnoxia et analytica. Praxis secretorum horum provisorum respectivorum regunt anonymi notati processus infrastructure.<br><br>

        <strong>4. Data Security</strong><br>
        Rationabilis securitatis mensurae ad suggestum tuendum implenda sunt. Sed nulla methodus tradendi in Interreti omnino securus est.<br><br>
    `,
    cookies_content: `
        <strong>1. Quid Crustulae et Loci at? </strong><br>
        Crustula et navigatrum repositionis localis parvae notitiae limae in fabrica repositae sunt ut recordarentur optionum conformationis trans visits.<br><br>.

        <strong>2. Syntaxis Purpose</strong><br>
        Naviculator LocalStorage stricte adhibetur ut occasus configurationis servet, ut: <br>
        - Lingua preferences<br>
        - User interface configuration (exempli causa, layout vel lemma occasus) <br>
        - Temporaria applicatio cache<br><br>

        <strong>3. No Tracking</strong><br>
        Crustulas et repositiones locales non adhibentur ad proposita venditionis tertia vel tertiae factionis. Data omnia condita stricte pro nucleo functionis suggesti.<br><br>

        <strong>4. Control</strong><br>
        Data navigatoris quovis tempore purgari possunt per occasus navigantium, qui figuras locales retexere.
    `,
    cookie_consent_text: "Crustulas fundamentales adhibemus ad curandum functiones website recte, ut sessionem tuam activam servans, praeter linguam tuam potiorem, aliasque conformationes consuetudinum.",
    read_policy: "Legere Quisque Policy",
    support_title: "Contactus Support",
    support_subject_label: "Subiectum",
    support_message_label: "Nuntius",
    support_submit_button: "Nuntius mitte",
    support_hint: "Nota: Hoc default electronicam tuam applicationem aperies ut nuntium mittas.",
    support_success_msg: "Aperire vestri email app...",
    support_error_msg: "Defecit mittere nuntium. Mox iterum conare.",
    explorer_title: "Explorer",
    history_title: "Historia",
    animation_title: "Animation",
    config_title: "Configurationis",
    tool_mouse: "Lego (CtrlTab + M)",
    tool_brush: "Peniculus (Ctrl+B)",
    tool_brush_mode: "Toggle Modus (Solidus / Serena)",
    tool_eraser: "Eraser (Ctrl+E)",
    tool_brush_size: "Adjust Peniculus Location",
    tool_bucket: "Imple (CtrlF +)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Eget (CtrlTab+Shift+B)",
    tool_rotate: "Rotate (CtrlTab + Shift + R)",
    tool_flip_h: "Flip H (CtrlTab+H)",
    tool_flip_v: "Flip V (CtrlTab+V)",
    tool_transpose: "Transponere (CtrlTab + Shift+T)",
    label_width: "Latitudo",
    label_height: "Altitudo",
    label_frames: "Numerus Frames",
    label_animation: "Animation Style",
    label_background_color: "Coloris background",
    label_interval: "Intervallum",
    tool_anim_config: "Animation configurationis",
    label_new_width: "Nova Latitudo",
    label_new_height: "Altitudo nova",
    label_apply: "Applicare",
    label_colors: "Colorum",
    label_size: "Magnitudo",
    label_tolerance: "tolerantia",
    val_horizontal: "Horizontal",
    val_vertical: "Vertical",
    val_sequence: "Sequentia",
    val_bounce: "REPENTE",
    val_random: "Random",
    val_solid: "Firmus",
    val_clear: "Patet",
    action_add_sheet: "Novae Sheet",
    action_import: "Import",
    action_export: "Exportare",
    action_sort_projects: "Sort",
    sort_date_old: "vetustissima primum",
    sort_date_new: "Novissima prima",
    sort_name_az: "Nomen (A-Z)",
    sort_name_za: "Nomen (Z-A)",
    action_new_sprite: "Novum Sprite",
    action_new_project: "Novum Project",
    modal_save_all_title: "Servare omnes Mutationes",
    modal_save_all_desc: "Eligere bonorum servare:",
    modal_save_selected: "Salvum Lego",
    action_saved: "salvus",
    modal_create_sprite_title: "Novam Sprite",
    modal_create_project_title: "Create New Project",
    modal_add_sheet_title: "Add New Sheet",
    modal_rename_sheet_title: "Rename Sheet",
    modal_rename_sprite_title: "Rename Sprite",
    modal_delete_sprite_title: "Delere Sprite",
    modal_delete_project_title: "Delere Project",
    modal_delete_sheet_title: "Delere Sheet",
    placeholder_sprite_name: "Nomen",
    placeholder_project_name: "Nomen",
    placeholder_sheet_name: "Nomen",
    placeholder_new_name: "Nomen novum",
    action_create: "Create",
    action_add: "Add",
    action_rename: "Rename",
    action_duplicate: "Duplicare",
    action_delete: "Delere",
    action_cancel: "Cancel",
    confirm_delete_sprite: "Certusne es vis hunc spiritum delere?",
    confirm_delete_project: "Visne vero hoc consilium delere? tesque omnes tollentur.",
    confirm_delete_sheet: "Visne vero hanc paginam delere?",
    err_select_sprite: "Prius elige quaeso assuetus.",
    err_select_project: "Primum consilium elige quaeso.",
    err_name_empty: "Nomen vacuum esse non potest.",
    err_sprite_exists: "Illo nomine iam spiritus est.",
    err_project_exists: "Iam exstat consilium cum eo nomine.",
    err_no_content: "Nulla id nisi nisi.",
    err_no_changes: "Nulla ut consequat nisi.",
    err_delete_last_sheet: "Ultima sheet potest delere.",
    err_extract_frames: "Posset extrahere aliquas tabulas.",
    err_indexeddb: "Defecit localiter servare. Navigabulum tuum IndexedDB non support.",
    msg_upload_success: "Index Prosperum: {0}",
    msg_upload_failed: "Index Deficio: {0}",
    msg_save_success: "Serva felix.",
    msg_saving: "Salvis...",
    msg_multi_save_result: "Servata {0} bona. {1} Peccatum.",
    menu_title: "Menu",
    menu_save: "Servare",
    menu_save_all: "Servare All",
    menu_support: "Contactus Support",
    label_local_storage: "Locus PRAECLUSIO",
    label_sign_in: "Signum in",
    modal_export_title: "Sprite exportare",
    label_filename: "Filename",
    label_format: "Forma",
    action_export_confirm: "Exportare",
};

export default translations;
